import { Component } from 'react'
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { commonClass } from '../../helpers/commonClass';
import { history } from '../../helpers/history';
import { alertActions } from '../../action/AlertAction';
import RenderCasino from './RenderCasino';

var popUpObj = null;
class HomeSlidTabs extends Component {
    constructor(props) {
        super(props);
    }

    componentDidMount() {
        if (window.SubDivs) {
            window.SubDivs()
        }
        if (window.ToggleControlAll) {
			window.ToggleControlAll();
		}
    }

    showMsg = (msg, flag) => {
        this.props.alertError(msg);
    }

    GotoLotto = (id) => {
        commonClass.IDPageControl(id)
    }
    
    GotoPreviourresult = (GameId) => {
        localStorage.setItem('drawtabId', 1);
        commonClass.IDPageControlDraws(GameId)
    }

    render() {
        const { t } = this.props;
        return (
            <div class="lft" id="sidebar">
                <div class="subGames">
                    <ul>
                        <li class="menu-item"><a class=""><div id="toggleBtn1" class="flaqIcon"><img src="./assets/img/icons/lotto.png" /></div><div class="sportsName">{t('lbllotto')}</div></a>
                            <ul className="dotNone">
                                <li onClick={() => { this.GotoLotto(1) }}><a><img src="./assets/img/icons/play-lotto.png" />Play Lotto</a></li>
                                <li onClick={() => { this.GotoLotto(2) }}><a><img src="./assets/img/icons/mini-lotto.png" />Mini Lotto</a></li>
                                <li onClick={() => { this.GotoLotto(3) }}><a><img src="./assets/img/icons/fast-lotto.png" />Fast Lotto</a></li>
                                <li onClick={() => { this.GotoLotto(4) }}><a><img src="./assets/img/icons/millionaire-lotto.png" />Millionaire Lotto</a></li>
                                <li onClick={() => { this.GotoLotto(5) }}><a><img src="./assets/img/icons/multi-millions-lotto.png" />Multi Million Lotto</a></li>
                                <li onClick={() => { this.GotoLotto(6) }}><a><img src="./assets/img/icons/super-mega-lotto.png" />Super Mega Million Lotto</a></li>
                                <li onClick={() => { history.push('/howtoplay') }}><a>{t('lblHowToPlay')}</a></li>
                            </ul>
                        </li>
                        <li class="menu-item"><a><div class="flaqIcon" id="toggleBtn2" ><img src="./assets/img/icons/scratch-cards.png" /></div><div class="sportsName">{t('lblscratch')}</div></a>
                            <ul>
                                <RenderCasino renderkey={4} />
                            </ul>
                        </li>
                        <li class="menu-item"><a><div class="flaqIcon" id="toggleBtn3" ><img src="./assets/img/icons/online-slots.png" /></div><div class="sportsName">{t('lblonlslot')}</div></a>
                            <ul>
                                <RenderCasino renderkey={2} />
                            </ul>
                        </li>
                        <li class="menu-item"><a><div class="flaqIcon" id="toggleBtn4" ><img src="./assets/img/icons/table-games.png" /></div><div class="sportsName">{t('lbltablegame')}</div></a>
                            <ul>
                                {/* <li><a onClick={() => history.push('/Roulette')}>Roulette</a></li>
                                <li><a onClick={() => history.push('/RouletteInstant')}>Roulette(Instant)</a></li> */}
                                <RenderCasino renderkey={6} />
                            </ul>
                        </li>

                        <li class="menu-item"><a><div class="flaqIcon" id="toggleBtn5" ><img src="./assets/img/icons/draws.png" /></div><div class="sportsName">{t('lblDraws')}</div></a>
                            <ul className="dotNone">
                                <li onClick={() => { this.GotoPreviourresult(1) }}><a><img src="./assets/img/icons/play-lotto.png" />Play Lotto</a></li>
                                <li onClick={() => { this.GotoPreviourresult(2) }}><a><img src="./assets/img/icons/mini-lotto.png" />Mini Lotto</a></li>
                                <li onClick={() => { this.GotoPreviourresult(3) }}><a><img src="./assets/img/icons/fast-lotto.png" />Fast Lotto</a></li>
                                <li onClick={() => { this.GotoPreviourresult(4) }}><a><img src="./assets/img/icons/millionaire-lotto.png" />Millionaire Lotto</a></li>
                                <li onClick={() => { this.GotoPreviourresult(5) }}><a><img src="./assets/img/icons/multi-millions-lotto.png" />Multi Million Lotto</a></li>
                                <li onClick={() => { this.GotoPreviourresult(6) }}><a><img src="./assets/img/icons/super-mega-lotto.png" />Super Mega Million Lotto</a></li>                                
                            </ul>
                        </li>
                    </ul>
                </div>
                <div class="subMenu">
                    <ul>
                        <li onClick={() => { history.push('/promotion') }} class="menu-item"><a class="" id="set1"><div class="flaqIcon" id="toggleBtn6" ><img src="./assets/img/icons/promotions.png" /></div><div class="sportsName">{t('lblPromotion')}</div></a>
                        </li>
                    </ul>
                </div>
                <div class="subMenu">
                    <ul>
                        <li class="menu-item" ><a class="" id="set1"><div class="flaqIcon" id="toggleBtn7" ><img src="./assets/img/icons/bonus.png" /></div><div onClick={() => { history.push('/bonus-details') }} class="sportsName">{t('lblbonus')}</div></a>
                        </li>
                        <li class="menu-item"><a class="" id="set1"><div class="flaqIcon" id="toggleBtn8"><img src="./assets/img/icons/vip.png" /></div><div class="sportsName">{t('lblvip')}</div></a>
                        </li>
                        <li class="menu-item"><a class="" id="set1"><div class="flaqIcon" id="toggleBtn9"><img src="./assets/img/icons/cash-backs.png" /></div><div class="sportsName">{t('lblcashback')}</div></a>
                        </li>
                    </ul>
                </div>
                <div class="subMenu">
                    <ul>
                        <li class="menu-item"><a class="" id="set1"><div class="flaqIcon" id="toggleBtn10" ><img src="./assets/img/icons/happy-palyers.png" /></div><div class="sportsName">{t('lblhomecomments')}</div></a>
                        </li>
                        <li class="menu-item"><a class="" id="set1"><div class="flaqIcon" id="toggleBtn11" ><img src="./assets/img/icons/sustainability.png" /></div><div class="sportsName">{t('lblsustain')}</div></a>
                        </li>
                        <li class="menu-item"><a class="" id="set1"><div class="flaqIcon" id="toggleBtn12" ><img src="./assets/img/icons/supports.png" /></div><div class="sportsName">{t('lblsupport')}</div></a>
                        </li>
                        <li class="menu-item" ><a class="" id="set1"><div class="flaqIcon" id="toggleBtn13"><img src="./assets/img/icons/faq.png" /></div><div onClick={() => { history.push('/faqs') }} class="sportsName">{t('lblFAQs')}</div></a>
                        </li>
                    </ul>
                </div>
            </div>
        )
    }

}


function mapStateToProps(state) {
    const { latestResult } = state.gameReducer;
    const { user, appvariables } = state.loginReducer;
    return { user, latestResult, appvariables };
}
const mapActionToProps = {
    alertError: alertActions.error

}
export default connect(mapStateToProps, mapActionToProps)(withTranslation()(HomeSlidTabs))

